import { useMutation } from "@tanstack/react-query";
import { getCityStats } from "@/api/city";
import { GetCityStatsData, CityData } from "@/types";

interface UseGetCityStatsOptions {
  onSuccess?: (data: CityData | CityData[]) => void;
  onError?: (error: any) => void;
}

export const useGetCityStats = ({ onSuccess, onError }: UseGetCityStatsOptions) => {
  return useMutation({
    mutationFn: (data: GetCityStatsData) => getCityStats(data),
    onSuccess,
    onError,
  });
};
